import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services/alert.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ProductSubCategoryService } from '../product-subcategory-service';
import { ProductService } from '../../product-management/product-service';
import Swal from 'sweetalert2';
import { MenusService } from 'src/app/_services/menu.service';

@Component({
  selector: 'app-product-subcategory-edit',
  templateUrl: './product-subcategory-edit.component.html',
  styleUrls: ['./product-subcategory-edit.component.scss']
})
export class ProductSubcategoryEditComponent implements OnInit {

  selectedFile: SafeUrl = 'assets/images/product.png';
  submitted: boolean = false;
  editSubcategoryForm !:FormGroup;
  categoryDropdownList : any[];
  id : any;
  productMappedList : any[];
  public permissions : any;
  dbStatus : string;
  selectedStatus : string;
  
  @ViewChild('editProductSubcategoryModalOpen') private editProductSubcategoryModal: ModalComponent;
  modalProductSubcategory: ModalConfig;
  constructor(private router : Router,private menuService : MenusService, private formBuilder : FormBuilder,private alertService : AlertService,private subCategoryService : ProductSubCategoryService,private route : ActivatedRoute,private productService : ProductService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

    const path = "/productSubcategory/productSubcategoryList";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);

    this.editSubcategoryForm = this.formBuilder.group({
      subCategoryImage : ['',Validators.required],
      subCategoryName : ['',Validators.required],
      subCategoryDesc : ['',Validators.required],
      category : [],
      status : []
    })

    this.subCategoryService.getCategoryDropdown().subscribe((response:any)=>{
      this.categoryDropdownList = response.response.data;
    })

    this.id = this.route.snapshot.queryParamMap.get("mid");
    this.subCategoryService.getSubCategoryById(this.id).subscribe((response:any)=>{
      console.log(response.response);
      this.setSubCategoryProfileByApi(response.response.data.icon);
      this.editSubcategoryForm.controls.subCategoryName.setValue(response.response.data.name);
      this.editSubcategoryForm.controls.subCategoryDesc.setValue(response.response.data.description);
      this.editSubcategoryForm.controls.category.setValue(response.response.data.categoryName);
      this.editSubcategoryForm.controls.status.setValue(response.response.data.status);
      this.dbStatus = response.response.data.status;
      this.selectedStatus = response.response.data.status;
      this.productMappedList = response.response.data.productDTOList;

    })

    this.modalProductSubcategory = {
      modalTitle: "Product Subcategory",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }

  cancelButton(){
    this.router.navigateByUrl('/productSubcategory/productSubcategoryList')
  }

  editProductSubcategory(data:any){
    console.log(data);
    this.submitted = true;
    if(this.editSubcategoryForm.valid){
      console.log("Valid");

      let requestForm = {
        "id" : this.id,
        "name": data.subCategoryName,
        "description": data.subCategoryDesc,
        // "productCategoryId" : data.category,
        // "status": data.status
      };

      var requestData = new FormData();
      requestData.append("icon",this.editSubcategoryForm.value.subCategoryImage);
      requestData.append("request",JSON.stringify(requestForm));
      console.log(requestData);
      this.subCategoryService.updateSubCategory(requestData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire(response.response.message, '', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/productSubcategory/productSubcategoryList']);
            } 
          });
        }else{
          Swal.fire(response.response.message, '', 'error');
        }
      })

    }else{
      console.log("Not Valid");
    }
    
  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.editSubcategoryForm.get('subCategoryImage')?.reset();
  }

  setSubCategoryProfileByApi(profile: any) {
    console.log("Choose File "+profile);
    let url = "sub-category/"+profile;
    this.productService.getProfileImage(url).subscribe((response:any)=>{
      console.log(response);

      if(response.type == 'application/json'){
        this.editSubcategoryForm.get('subCategoryImage')?.setValue(profile);
        this.selectedFile = 'assets/images/product.png';
      }else{
        let file = new File([response], url, { type: response.type });
        this.editSubcategoryForm.get('subCategoryImage')?.setValue(file);
        let imageUrl = URL.createObjectURL(response);
        this.selectedFile = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
      }
    })
  }

  setSubcategoryProfile(profile : any){
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    this.editSubcategoryForm.get('subCategoryImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data : "+reader.result)
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.editProductSubcategoryModal.close();
      this.editSubcategoryForm.controls.status.setValue(null);
    }
  }

  confirmModal(){
    this.editProductSubcategoryModal.close();
    this.editSubcategoryForm.controls.status.setValue("INACTIVE");
  }

  subCategoryStatusChange(selectedStatus: any){
    this.selectedStatus = selectedStatus;
    if(this.selectedStatus == "INACTIVE"){
      this.editProductSubcategoryModal.open();
    }
  }

  // Method to validate subcategory name input (alphanumeric, underscore, and spaces allowed)
  onSubcategoryNameKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate subcategory description input (alphanumeric, underscore, and spaces allowed)
  onSubcategoryDescKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  statusUpdate(){
    if(this.selectedStatus == undefined){
      Swal.fire('Please select Status','','error');
      return;
    }
    if(this.dbStatus == this.selectedStatus){
      Swal.fire('Status is already '+this.selectedStatus,'','error');
    }else{
      this.productService.subCategoryStatusChange(this.id,this.selectedStatus).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Status Updated Successfully','','success');
        }else{
          Swal.fire(response.response.message,'','error');
        }
      })
    }
  }

}
